import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HelpIcon } from '@dixa/lib-shared-habla';
import Spinner from '../../ajax/components/Spinner';
import './styles/input-field.less';
const InputField = ({ displayName, style, type, disabled, hidden, required, placeholder, input, meta, showSpinner, className, showHelpIcon, helpIconTitle, helpIconText, onChangeAction, onBlurAction, onKeyDownAction, min, step, max, maxLength, autoFocus, hasPrefix, }) => {
    const setFous = autoFocus ? autoFocus : false;
    const name = input.name;
    let formGroupClasses = className && typeof className === 'string' ? className : '';
    let isDisabled = '';
    let validationErrors = null;
    let isRequired = null;
    let spinner = null;
    let helpIcon = null;
    let placeholderValue = '';
    let prefix = null;
    if (meta && meta.touched === true && meta.valid === true) {
        formGroupClasses += ' has-success';
    }
    else if (meta && meta.touched === true && meta.error) {
        formGroupClasses += ' has-error';
        validationErrors = _jsx("span", Object.assign({ className: "validation-text" }, { children: meta.error }));
    }
    if (meta && meta.active === true) {
        formGroupClasses += ' focused';
    }
    if (hidden === true) {
        formGroupClasses += ' hidden';
    }
    if (disabled === true) {
        formGroupClasses += ' disabled';
        isDisabled = 'disabled';
    }
    if (placeholder === null || placeholder === undefined) {
        placeholderValue = displayName + '...';
    }
    else {
        placeholderValue = placeholder;
    }
    if (required === true) {
        isRequired = 'required';
    }
    if (showSpinner === true) {
        spinner = _jsx(Spinner, { className: "dark input" });
    }
    if (showHelpIcon === true) {
        helpIcon = (_jsx("span", Object.assign({ className: "helpIcon" }, { children: _jsx(HelpIcon, { text: helpIconText, title: helpIconTitle }) })));
    }
    if (hasPrefix) {
        prefix = (_jsx("span", Object.assign({ className: "input-group-addon" }, { children: _jsx("b", { children: "https://" }) })));
    }
    return (_jsxs("div", Object.assign({ className: `form-group ${formGroupClasses}`, style: style }, { children: [displayName !== '' && (_jsxs("label", Object.assign({ className: "control-label", htmlFor: name }, { children: [displayName, " ", required === true ? '*' : '', " ", validationErrors] }))), helpIcon, _jsxs("div", Object.assign({ className: "input-group" }, { children: [prefix, _jsx("input", { id: name, value: input.value, autoFocus: setFous, onBlur: (e) => {
                            input.onBlur(e);
                            if (typeof onBlurAction === 'function') {
                                onBlurAction(e);
                            }
                        }, onFocus: (e) => {
                            input.onFocus(e);
                        }, checked: input.checked, onChange: (e) => {
                            if (typeof onChangeAction === 'function') {
                                onChangeAction(e);
                            }
                            input.onChange(e);
                        }, onKeyDown: (e) => {
                            if (typeof onKeyDownAction === 'function') {
                                onKeyDownAction(e);
                            }
                        }, min: min, max: max, step: step, maxLength: maxLength, required: isRequired, disabled: isDisabled, className: "form-control", type: type, placeholder: placeholderValue })] })), spinner] })));
};
export default InputField;
